import React from 'react';
import classNames from 'classnames/bind';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import { Heading } from 'components';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { SharedZoneBlocks, SharedZonePromoBlocks } from 'store/SharedZone/blocks/selectors';

import PromoBlockImage from '../PromoBlockImage';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const PromoBlockContainer = ({
  align,
  children,
  className,
  description,
  headline,
  headlineTagName,
  imgSrc,
  isCompact,
  isList,
  isMobile,
  isMobileBrowser,
  isPrimary,
  subHeadline,
}) => {
  return (
    <div className={cx('container', { compact: isCompact, primary: isPrimary }, align, className)}>
      {!isMobileBrowser && headline && (
        <Heading className={cx('heading')} level={isMobile ? 4 : 2} tagName={headlineTagName}>
          {parseHtmlToReact(headline)}
        </Heading>
      )}

      <div className={cx('component', isMobileBrowser && 'mobile')}>
        <div className={cx('content')}>
          <div>
            {isMobileBrowser && headline && (
              <Heading
                className={cx('heading', isMobileBrowser && 'mobile')}
                level={isMobile ? 4 : 2}
                tagName={headlineTagName}
              >
                {parseHtmlToReact(headline)}
              </Heading>
            )}
            {subHeadline && (
              <Heading
                className={cx('subHeading', isMobileBrowser && 'mobile')}
                level={isMobile ? 4 : 2}
                tagName="p"
              >
                {parseHtmlToReact(subHeadline)}
              </Heading>
            )}
            {description && (
              <div className={cx('contentDescription')}>{parseHtmlToReact(description)}</div>
            )}
          </div>
          {children}
        </div>
        <div className={cx('media')}>
          <PromoBlockImage imgSrc={imgSrc} isCompact={isCompact} isList={isList} />
        </div>
      </div>
    </div>
  );
};

PromoBlockContainer.propTypes = {
  align: PropTypes.oneOf(['right']),
  children: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.string,
  headline: PropTypes.string,
  headlineTagName: PropTypes.string,
  imgSrc: PropTypes.string,
  isCompact: PropTypes.bool,
  isList: PropTypes.bool,
  isMobile: PropTypes.bool,
  isMobileBrowser: PropTypes.bool,
  isPrimary: PropTypes.bool, // Основные блоки стилистически выделяются сильнее обычных
  subHeadline: PropTypes.string,
};

const mapStateToProps = (state) => ({
  align: SharedZonePromoBlocks.getAlign(state),
  isCompact: isScreenBelow640(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(PromoBlockContainer);
